import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "not-found-content" }
const _hoisted_2 = { class: "not-found-box" }
const _hoisted_3 = { class: "button" }

import { Action } from '@/typeDefine/CommonTypes';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'NotFound',
  setup(__props) {

const router = useRouter()
const imgSrc: string = new URL(`../assets/images/404.jpg`, import.meta.url).href

const goHome: Action = () => {
    router.replace({
        name: 'index'
    })
}

const goBack: Action = () => {
    router.back()
}


return (_ctx: any,_cache: any) => {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_empty, {
        description: "You have accessed a resource that does not exist. Please make sure the path is correct.",
        image: _unref(imgSrc),
        "image-size": "500"
      }, null, 8, ["image"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_button, {
        plain: "",
        link: "",
        size: "large",
        onClick: goHome
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(" 首页 ")
        ])),
        _: 1,
        __: [0]
      }),
      _createVNode(_component_el_button, {
        plain: "",
        link: "",
        size: "large",
        onClick: goBack
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode(" 返回 ")
        ])),
        _: 1,
        __: [1]
      })
    ])
  ]))
}
}

})